module.exports = __webpack_public_path__ + "img/ditu.448869a8.png";